import { TransactionModes, Instrument, OrderCategory, MarketKeywords, SortingTypes } from 'sharedweb/app.structs';
import { OrderStatus, BOCOOrderStatus, OrderMode, OrderValidity, OrderType, ProductTypeSettingsCaps } from '../app.structs';
import { SortingInterface } from 'sharedweb/app.interface';
import { SecurityTypeMapping } from 'src/app/app.interfaces';


// Max limit of the search limit for the symbol search
export const MAX_SEARCH_RESULTS = 30;

export const VALID_ORDERS = [
    OrderStatus.confirmed, OrderStatus.partially_filled, OrderStatus.replaced,
    OrderStatus.pending_new, OrderStatus.pending_replace, OrderStatus.pending_cancel,
    OrderStatus.amo_pending, OrderStatus.amo_replaced, OrderStatus.filled,
    OrderStatus.cancelled, OrderStatus.schedule_new, OrderStatus.schedule_pending,
    OrderStatus.schedule_replaced, OrderStatus.schedule_cancelled, 
];

export const LOCAL_STORAGE_KEYS = {
    userInfo: 'USER_INFO',
    lastClickedSymbol: 'LAST_CLICKED_SYMBOL',
    messages: 'MESSAGES',
    userBook: 'USER_BOOK',
    selectedMarketWatch: 'MARKET_WATCH',
    urls: 'URLS',
    logLevel: 'LOG_LEVEL',
    edisRequired: 'EDIS_REQUIRED',
    ipoExpandedId: 'IPOExpandedId',
    tempUserInfo: 'TEMP_USER_INFO',
    totpUserInfo: 'TOTP_USER_INFO',
    nextParam: 'NEXT_PARAM',
    activeTab: 'ACTIVE_TAB',
};

export const PAN_LENGTH = 10;

// GMT_IST_DIFFERENCE is the time in seconds
export const GMT_IST_DIFFERENCE_SEC = 19800;

export const MIN_QUANTITY = 1;

export const PRICE_MAX_LENGTH = 7;

export const QUANTITY_LENGTH = 7;

export const MAX_IPO_PRICE = 200000;

export const CURRENCY_SYMBOL = '\u20B9';

export const OTP_RESEND_TIMER = 30;

export const REG_EX = {
    id: '^[a-zA-Z0-9]+$',
    phone: '(\\+[\\d]{1,5}|0)?[7-9]\\d{9}',
    contains_special_char: '^[a-zA-Z0-9]+$',
    contains_mixed_case: '((?=.*[a-z])(?=.*[A-Z]))',
    contains_digit: '.*[0-9].*',
    hex_color: '^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$',
    integer_only: '^[0-9]*$',
    negative_float_values: /^-?\d*\.?\d*$/,
    negative_integer_values: /^-?\d*$/,
    // adding global flag in notNumbers regex, as when replaceAll method called in regexDirective, 
    // it is throwing error which results in failed number input validation.
    notNumbers: /[^0-9]+/g,
    contains_float_values: /^([0-9]+\.?[0-9]*)$/,
    upi: /^[a-zA-Z0-9.\-_]{2,256}$/,
    payment_upi: /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
    no_spaces: /\s+/g,
    pan: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
    digitsOnly: /^\d+$/,
};

// special event keyCodes
/**
 * Backspace = 8 , Tab = 9 , Enter = 13 , Shift = 16 , Control = 17 , Alt = 18
 * Caps Lock = 20 , Escape = 27 , Space = 32 , Page Up = 33 , Page Down = 34 , End = 35
 * Home = 36 , Left = 37 , Up = 38 , Right = 39 , Down = 40 , Delete = 46
 */
export const keys = [8, 9, 13, 16, 17, 18, 20, 27, 32, 33, 34, 35, 36, 37, 38, 39, 40, 46];


// GMT_IST_DIFFERENCE is the time in milli-seconds
export const GMT_IST_DIFFERENCE = GMT_IST_DIFFERENCE_SEC * 1000;

export const SPECIAL_SYMBOLS = '/[- &*. ]/';

export const DEFAULT_TOAST_DURATION = 5000;

export const ENV_CONFIG = {
    useRadioOrderModeTab: true,
    disclosedQtyDisabledMarkets: [
        'MSEFO',
        'MSECD'
    ],
    handledMarketConnectivity: [
        'MSECD',
        'MSEFO',
        'MSECM',
        'ESMNSE'
    ],
    maxPriceAllowed: 1e6,
    maxQtyAllowed: 9999999,
    defaultPasswordPolicy: {
        contains_digit: true,
        contains_mixed_case: true,
        contains_special_char: true,
        max_length: 12,
        min_length: 8,
        otp_retries_allowed: 5,
    },
    defaultChart: 'echarts'
};

export const IONIC_EVENTS = {
    showToast: 'SHOW_TOAST',
    showLoading: 'SHOW_LOADING',
    hideLoading: 'HIDE_LOADING',
    goToLoginPage: 'GO_TO_LOGIN_PAGE',
    changeSetRoot: 'CHANGE_ROOT_PAGE',
    LogOut: 'LOG_OUT',
    updateKycStatus: 'UPDATE_KYC_STATUS',
    symbolsLoaded: 'SYMBOLS_LOADED',
    executeLogout: 'EXECUTE_LOGOUT',
    marketwatchChanged: 'MARKETWATCH_CHANGED',
    orderBookChanged: 'ORDRBOOK_CHANGED',
    showModal: 'SHOW_MODAL',
    deletemw: 'DELETE_MARKET_WATCH',
    closeReorder: 'CLOSE_REORDER',
    socketConnected: 'SOCKET_CONNECTED',
    openFilterDialog: 'OPEN_FILTER_DIALOG',
    refreshIPOOrderbook: 'REFRESH_IPO_ORDER_BOOK',
    updateFundsReport: 'UPDATE_FUNDS_REPORT',
    chartLoaded: 'CHART_LOADED',
    tabChanged: 'TAB_CHANGED',
    PIN_SYMBOLS: 'PIN_SYMBOLS',
    AddDeleteSymbols: 'ADD_DELETE_SYMBOLS',
    PortfolioTabChanged: 'PORTFOLIO_CHANGED',
    TOTPStatus: 'TOTP_STATUS',
};

export const KYC_BUISSNESS_UID = '4fef03cc-cbda-11e9-97c9-42010a800003';

export const HOLDING_MARKET_PRIORITY_LIST = ['NSECM', 'BSECM', 'MSECM'];

export const cancelNotAllowedOrderStatus = [
    OrderStatus.cancelled,
    OrderStatus.replace_rejected,
    OrderStatus.new_rejected,
    OrderStatus.rms_reject,
    OrderStatus.frozen,
    OrderStatus.pending_new,
    OrderStatus.pending_replace,
    OrderStatus.pending_cancel,
    OrderStatus.filled,
    BOCOOrderStatus.Exit,
    OrderStatus.amo_rejected,
    OrderStatus.amo_cancelled,
    OrderStatus.amo_replace_rejected,
    OrderStatus.amo_cancel_rejected,
    OrderStatus.schedule_cancelled,
    OrderStatus.schedule_rejected
];

export const modifyNotAllowedOrderStatus = [
    OrderStatus.cancelled,
    OrderStatus.replace_rejected,
    OrderStatus.new_rejected,
    OrderStatus.rms_reject,
    OrderStatus.frozen,
    OrderStatus.pending_new,
    OrderStatus.pending_replace,
    OrderStatus.pending_cancel,
    OrderStatus.filled,
    BOCOOrderStatus.Exit,
    OrderStatus.amo_rejected,
    OrderStatus.amo_cancelled,
    OrderStatus.amo_replace_rejected,
    OrderStatus.amo_cancel_rejected,
    OrderStatus.schedule_cancelled,
    OrderStatus.schedule_rejected
];

export const rejectedOrderStatus = [
    OrderStatus.replace_rejected,
    OrderStatus.new_rejected,
    OrderStatus.rms_reject,
    OrderStatus.amo_rejected,
    OrderStatus.amo_replace_rejected,
    OrderStatus.amo_cancel_rejected
];

export const FIRST_TIME_DEFAULT_ORDER_SETTINGS = {
    orderMode: OrderMode.Buy,
    orderValidity: OrderValidity.DAY,
    orderType: OrderType.Limit,
    product: ProductTypeSettingsCaps.Intraday,
    quantity: 1
};

export const TRANSFER_MODES = [
{
    id: TransactionModes.Deduction,
    label: 'Deduction'
},{
    id: TransactionModes.Payin,
    label: 'Deposit'
}, {
    id: TransactionModes.Payout,
    label: 'Withdraw'
}, {
    id: TransactionModes.All,
    label: 'All'
}];


// These colors will not change acc. to theme and there was no other efficient way to arrange these colors according to
// market_id in css file , so stored at constants.
export const SEARCH_CHIP_COLORS = {
    NSECM: ['#4DAF7C', '#FFFFFF'],
    NSEFO: ['#B2B2B2', '#1D1D1D'],
    NSECDS: ['#71D6FF', '#1D1D1D'],
    NSECOM: ['#CE5DF7', '#FFFFFF'],
    BSECM: ['#FFB9B2', '#C0392B'],
    BSEFO: ['#B2B2B2', '#1D1D1D'],
    BSECDS: ['#B8B2FF', '#484848'],
    BSECOM: ['#5DF7A4', '#484848'],
    MCX: ['#F7BC5D', '#484848'],
    NCDEX: ['#F75DBC', '#FFFFFF'],
    ESMNSE: ['#4DAF7C', '#FFFFFF'],
    MSECM: ['#4DAF7C', '#FFFFFF'],
    MSEFO: ['#F8E025', '#EF6B0B'],
    MSECD: ['#71D6FF', '#1D1D1D'],
};

// These colors will not change acc. to theme and there was no other efficient way to arrange these colors according to
// status in css file , so stored at constants.
export const ORDER_STATUS_COLOR_MAP = {
    ['rms_reject']: ['#FCC2C2', '#D95F5F'],
    ['new_rejected']: ['#FCC2C2', '#D95F5F'],
    ['amo_rejected']: ['#F4DDFF', '#B576FF'],
    ['confirmed']: ['#C9F5FF', '#28AEE4'],
    ['amo_cancelled']: ['#FAC5C5', '#D56054'],
    ['amo_pending']: ['#C9F5FF', '#28AEE4'],
    ['amo_replaced']: ['#C9F5FF', '#28AEE4'],
    ['filled']: ['#98EDB9', '#11816B'],
    ['partially_filled']: ['#FCE1BD', '#4DAF7C'],
    ['cancelled']: ['#FAC5C5', '#D56054'],
    ['ipo_closed']: ['#F0F0F0', '#2c3e50'],
    ['ipo_cancelled']: ['#ED32371F', '#ED3237'],
    ['success']: ['#E1F1E1', '#43A646'],
    ['upcoming']: ['#017DC31F', '#017dc3'],
};

export const IPO_TO_ORDER_STATUS_MAP = {
    'upcoming': 'upcoming',
    'closed': 'ipo_closed',
    'P': 'success',
    'R': 'ipo_cancelled',
    'C': 'ipo_cancelled',
    's': 'success',
    'n': 'success',
    'm': 'success',
    'p': 'success',
    'd': 'ipo_cancelled',
    'r': 'ipo_cancelled',
    'f': "ipo_cancelled"
};

export const DEFAULT_PINNED_SYMBOLS_OBJ = [
    {
        symbol_id: 100300000026000,
        symbol: 'NIFTY 50',
        ltp: null,
        change_in_price: null,
        perChange: null,
        scrip_precision: 2,
        market_id: 'NSECM',
        security_id: 26000,
        is_index: true
    },
    {
        symbol_id: 100100000000001,
        symbol: 'SENSEX',
        ltp: null,
        change_in_price: null,
        perChange: null,
        scrip_precision: 2,
        market_id: 'BSECM',
        security_id: 1,
        is_index: true
    }
];

export const CACHE__KEYS = {
    pinnedSymbol: 'pinnedSymbolWeb',
};

export const DEFAULT_PINNED_INDICES_OBJ = [
    {
        marketId: 'NSECM',
        id: 0,
        symbol_id: 100300000026000,
        name: 'NIFTY 50',
        ltp: 0,
        change: 0,
        perChange: 0,
        close: 0,
        security_id: 26000,
        expanded: false
    },
    {
        marketId: 'BSECM',
        id: 0,
        symbol_id: 100100000000001,
        name: 'SENSEX',
        ltp: 0,
        change: 0,
        perChange: 0,
        close: 0,
        security_id: 1,
        expanded: false
    },
];

export const sortObj: SortingInterface[] = [{
    id: 1,
    iconText: 'A-Z',
    text: 'Alphabatically',
    state: SortingTypes.None,
    key: 'scrip_name'
},
{
    id: 2,
    iconText: 'CHG',
    text: 'Change',
    state: SortingTypes.None,
    key: 'change_in_price'
},
{
    id: 3,
    iconText: '%',
    text: 'Change in %',
    state: SortingTypes.None,
    key: 'perChange'
},
{
    id: 4,
    iconText: 'LTP',
    text: 'Last Traded Price',
    state: SortingTypes.None,
    key: 'last_trade_price'
},
{
    id: 5,
    iconText: 'EXH',
    text: 'Exchange',
    state: SortingTypes.None,
    key: 'market_id'
}];

export const HOLDINGS_PRIORITY_LIST = ['NSECM', 'BSECM', 'MSECM'];
export const ERROR_CODES = {
    EDIS_PENDING: 1034
};

export const MAX_EDIS_HOLDINGS = 100;

export const MAX_POSSIBLE_VALUE = 999999999;

export const MAX_TOTAL_PAYABLE = 200000;

export const DEFAULT_PRECISION = 2;

export const DEFAULT_TRADE_VALUE = 1;

export const DEFAULT_RECORDS_COUNT = 10;

export const DATE_TIME_FORMAT_UTILITY_II = 'DD-MMM-YYYY';

export const DATE_TIME_FORMAT_UTILITY_III = 'DDMMMYYYY';

export const DATE_TIME_FORMAT_UTILITY_IV = 'YYYY-MM-DD';

export const SYMBOL_SEARCH_ORDER_MARKET: string[] = [
    MarketKeywords.NSECM,
    MarketKeywords.BSECM,
    MarketKeywords.NSEFO,
    MarketKeywords.BSEFO,
    MarketKeywords.NSECDS,
    MarketKeywords.BSECDS,
    MarketKeywords.MCX,
    MarketKeywords.NCDEX,
    MarketKeywords.MSECM,
    MarketKeywords.MSEFO,
    MarketKeywords.MSECD,
    MarketKeywords.ESM
];

export const SYMBOL_SEARCH_ORDER_INSTRUMENT_TYPE = [
    Instrument['common_stock'],
    Instrument['index'],
    Instrument['future'],
    Instrument['option'],
];

export const SYMBOL_SEARCH_ORDER_CONTRACT_TYPE = [
    OrderCategory.single,
    OrderCategory.spread
];

export const MARGIN_SUMMARY_INTERVAL = 3000;

export const THROTTLER_MAP = {
    MARKET_WATCH_THROTTLE: 500,
    MARKET_INDEX_THROTTLE: 500,
    HOLDING_THROTTLE: 1500,
    POSITION_THROTTLE: 1500,
    MARKET_WATCH_EVENT_THROTTLE: 100,
    MARKET_WATCH_INDEX_EVENT_THROTTLE: 100,
    HOLDING_EVENT_THROTTLE: 500,
    MTF_HOLDING_EVENT_THROTTLE: 500,
    POSITION_EVENT_THROTTLE: 500,
    PRICE_DEPTH_THROTTLE: 500,
    PRICE_DEPTH_EVENT_THROTTLE: 100,
    ORDERBOOK_THROTTLE: 1500,
    TRADEBOOK_THROTTLE: 1500,
    GTTBOOK_THROTTLE: 1500,
    SMARTBOOK_THROTTLE: 1500,
    BATCHORDER_THROTTLE: 1500,
    ORDERBOOK_EVENT_THROTTLE: 500,
    BATCHORDER_EVENT_THROTTLE: 500,
    TRADEBOOK_EVENT_THROTTLE: 500,
    POSITION_SUMMARY_THROTTLE: 1500,
    POSITION_SUMMARY_EVENT_THROTTLE: 500,
    POSITION_CHART_THROTTLE: 1500,
    POSITION_CHART_EVENT_THROTTLE: 500,
    HOLDING_SUMMARY_THROTTLE: 1500,
    HOLDING_SUMMARY_EVENT_THROTTLE: 500,
};

export const MAXIMUM_CANDLES_REQUEST_LIMIT = 1500
export const MINIMUM_CANDLE_SIZE = 60

export const ESCALATION_LINKS = [
    {
        key: 'SEBI',
        value: 'https://scores.gov.in/scores/Welcome.html'
    },
    {
        key: 'NSE',
        value: 'https://investorhelpline.nseindia.com/NICEPLUS'
    },
    {
        key: 'BSE',
        value: 'https://bsecrs.bseindia.com/ecomplaint/frmInvestorHome.aspx'
    },
    {
        key: 'MCX',
        value: 'https://www.mcxindia.com/Investor-Services'
    }
    , {
        key: 'NCDEX',
        value: 'https://ncdex.com/investor_complaint'
    },
    {
        key: 'CDSL',
        value: 'https://www.cdslindia.com/Footer/grievances.aspx'
    },
    {
        key: 'SMARTODR',
        value: 'https://smartodr.in/login'
    }
]

export const SECRET_KEY_LENGTH = 32;

export const REST_API = 'LOGINAPI';

export const TWO_FA_EOD_TOKEN_REFRESH_TIME = 25;

export const MAX_QUANTIY_IPO_INVESTOR_TYPE = 200000;

export const MAX_UPI_LIMIT = 200000;

export const MAX_NETBANKING_LIMIT = 10000000;

export const MAX_AMOUNT_DIGITS_LIMIT = 8;

export const SECURITY_TYPE_SERIES_MAP: SecurityTypeMapping = {
    'Equity': {
      'BSECM': ['A', 'BE', 'T', 'XT', 'X', 'Z', 'Y', 'P', 'M', 'ZP', 'R', 'GC', 'MS', 'TS', 'W'],
      'NSECM': ['EQ', 'XT', 'X', 'T']
    },
    'Debt Instruments': {
      'BSECM': ['F'],
      'NSECM': [
        'N1', 'N2', 'N3', 'N4', 'N5', 'N6', 'N7', 'N8', 'N9',
        'NA', 'NB', 'NC', 'ND', 'NE', 'NF', 'NG', 'NH', 'NI', 'NJ', 'NK', 'NL', 'NM',
        'NN', 'NO', 'NP', 'NQ', 'NR', 'NS', 'NT', 'NU', 'NV', 'NW', 'NX', 'NY', 'NZ',
        
        'Y1', 'Y2', 'Y3', 'Y4', 'Y5', 'Y6', 'Y7', 'Y8', 'Y9',
        'YA', 'YB', 'YC', 'YD', 'YE', 'YF', 'YG', 'YH', 'YI', 'YJ', 'YK', 'YL', 'YM',
        'YN', 'YO', 'YP', 'YQ', 'YR', 'YS', 'YT', 'YU', 'YV', 'YW', 'YX', 'YY', 'YZ',
        
        'Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7', 'Z8', 'Z9',
        'ZA', 'ZB', 'ZC', 'ZD', 'ZE', 'ZF', 'ZG', 'ZH', 'ZI', 'ZJ', 'ZK', 'ZL', 'ZM',
        'ZN', 'ZO', 'ZP', 'ZQ', 'ZR', 'ZS', 'ZT', 'ZU', 'ZV', 'ZW', 'ZX', 'ZY', 'ZZ',
        
        'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'D8', 'D9',
        'DA', 'DB', 'DC', 'DD', 'DE', 'DF', 'DG', 'DH', 'DI', 'DJ', 'DK', 'DL', 'DM',
        'DN', 'DO', 'DP', 'DQ', 'DR', 'DS', 'DT', 'DU', 'DV', 'DW', 'DX', 'DY', 'DZ',
        
        'S1', 'S2', 'S3', 'S4', 'S5', 'S6', 'S7', 'S8', 'S9',
        'SA', 'SB', 'SC', 'SD', 'SE', 'SF', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM',
        'SN', 'SO', 'SP', 'SQ', 'SR', 'SS', 'ST', 'SU', 'SV', 'SW', 'SX', 'SY', 'SZ'
      ]
    },
    'Preference Shares': {
      'BSECM': ['-'],
      'NSECM': [
        'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9',
        'PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'PG', 'PH', 'PI', 'PJ', 'PK', 'PL', 'PM',
        'PN', 'PO', 'PP', 'PQ', 'PR', 'PS', 'PT', 'PU', 'PV', 'PW', 'PX', 'PY', 'PZ',
        
        'O1', 'O2', 'O3', 'O4', 'O5', 'O6', 'O7', 'O8', 'O9',
        'OA', 'OB', 'OC', 'OD', 'OE', 'OF', 'OG', 'OH', 'OI', 'OJ', 'OK', 'OL', 'OM',
        'ON', 'OO', 'OP', 'OQ', 'OR', 'OS', 'OT', 'OU', 'OV', 'OW', 'OX', 'OY', 'OZ',
        
        'Q1', 'Q2', 'Q3', 'Q4', 'Q5', 'Q6', 'Q7', 'Q8', 'Q9',
        'QA', 'QB', 'QC', 'QD', 'QE', 'QF', 'QG', 'QH', 'QI', 'QJ', 'QK', 'QL', 'QM',
        'QN', 'QO', 'QP', 'QQ', 'QR', 'QS', 'QT', 'QU', 'QV', 'QW', 'QX', 'QY', 'QZ',
        
        'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9',
        'FA', 'FB', 'FC', 'FD', 'FE', 'FF', 'FG', 'FH', 'FI', 'FJ', 'FK', 'FL', 'FM',
        'FN', 'FO', 'FP', 'FQ', 'FR', 'FS', 'FT', 'FU', 'FV', 'FW', 'FX', 'FY', 'FZ'
      ]
    },
    'Convertible Warrants': {
      'BSECM': ['FC'],
      'NSECM': [
        'W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9',
        'WA', 'WB', 'WC', 'WD', 'WE', 'WF', 'WG', 'WH', 'WI', 'WJ', 'WK', 'WL', 'WM',
        'WN', 'WO', 'WP', 'WQ', 'WR', 'WS', 'WT', 'WU', 'WV', 'WW', 'WX', 'WY', 'WZ',
        
        'K1', 'K2', 'K3', 'K4', 'K5', 'K6', 'K7', 'K8', 'K9',
        'KA', 'KB', 'KC', 'KD', 'KE', 'KF', 'KG', 'KH', 'KI', 'KJ', 'KK', 'KL', 'KM',
        'KN', 'KO', 'KP', 'KQ', 'KR', 'KS', 'KT', 'KU', 'KV', 'KW', 'KX', 'KY', 'KZ'
      ]
    },
    'Mutual Funds': {
      'BSECM': ['E'],
      'NSECM': ['MF', 'ME']
    },
    'Government Securities': {
      'BSECM': ['G'],
      'NSECM': ['GS', 'SG', 'GB', 'TB']
    },
    'Investment Trusts': {
      'BSECM': ['IF'],
      'NSECM': ['IV', 'ID', 'RR', 'RT']
    }
};